/**

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import { forwardRef } from "react";
import type { ComponentProps } from "react";
import type { SwitchProps } from "@mui/material/Switch";

// Custom styles for VuiSwitch
import VuiSwitchRoot from "components/VuiSwitch/VuiSwitchRoot";

type OwnerState = ComponentProps<typeof VuiSwitchRoot>["ownerState"];

type VuiSwitchProps = Omit<SwitchProps, keyof OwnerState> & Partial<OwnerState>;

const VuiSwitch = forwardRef<HTMLButtonElement, VuiSwitchProps>(
  ({ color = "white", size = "medium", ...rest }, ref) => (
    <VuiSwitchRoot {...rest} ref={ref} color="white" size={size} ownerState={{ color, size }} />
  )
);

export default VuiSwitch;
